import request from '@/utils/request';
export default {
  /**
  * 查询
  */
  query(data) {
    return request({
      url: '/ipark/pay_order/query',
      method: 'POST',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/ground-parking/pay-record.js